import { IdwDbApi, IdwInfoApi, IdwRwcApi, MigrationApi, SkillApi, MemoryApi, ChannelApi, DomainApi, DomainRelationshipApi, } from './api';
import { FlowApi } from './api';
export class IdwApi {
    constructor(config) {
        this.skillApi = new SkillApi(config);
        this.memoryApi = new MemoryApi(config);
        this.channelApi = new ChannelApi(config);
        this.domainApi = new DomainApi(config);
        this.domainRelationshipApi = new DomainRelationshipApi(config);
        this.migrationApi = new MigrationApi(config);
        this.idwInfoApi = new IdwInfoApi(config);
        this.idwDbApi = new IdwDbApi(config);
        this.idwRwcApi = new IdwRwcApi(config);
        this.flowApi = new FlowApi(config);
    }
}
//# sourceMappingURL=idwApi.js.map